import { useState } from "react";
import Select from "react-select";
import Button from "../UI/Button";
import {
  deleteObject,
  getDownloadURL,
  getStorage,
  ref,
  uploadBytes,
} from "firebase/storage";
import { deleteDoc, doc, updateDoc } from "firebase/firestore";
import { db } from "@/firebase/firebaseConfig";

const EditProduct = ({ product, onClose }) => {
  const [img, setImg] = useState(product.imageUrl);
  const [loading, setLoading] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [formData, setFormData] = useState({
    name: product.name,
    lastMonthSales: product.lastMonthSales,
    purchasePrice: product.purchasePrice,
    marketplacePrice: product.marketplacePrice,
    profit: product.profit,
    minQuantity: product.minQuantity,
    recQuantity: product.recQuantity,
    style: product.style,
    logistContact: product.logistContact,
    supplierContact: product.supplierContact,
    commercial: product.commercial,
  });

  const [selectedCountries, setSelectedCountries] = useState(
    Array.isArray(product.countries)
      ? product.countries.map((country) => ({ value: country, label: country }))
      : []
  );

  const countryOptions = [
    { value: "США", label: "США" },
    { value: "ОАЭ", label: "ОАЭ" },
    { value: "Европа", label: "Европа" },
    { value: "Япония", label: "Япония" },
  ];

  const handleSelectChange = (selectedOptions) => {
    setSelectedCountries(selectedOptions);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImg(file);
    } else {
      setImg(product.imageUrl);
    }
  };

  const storage = getStorage();

  const handleUpdate = async () => {
    try {
      setLoading(true);
      let updatedImageUrl = img;

      if (img && img instanceof File) {
        const storageRef = ref(storage, `products/${Date.now()}-${img.name}`);
        await uploadBytes(storageRef, img);
        updatedImageUrl = await getDownloadURL(storageRef);
      }

      const productRef = doc(db, "products", product.id);
      await updateDoc(productRef, {
        imageUrl: updatedImageUrl,
        countries: selectedCountries.map((c) => c.value),
        ...formData,
      });

      alert("Продукт обновлен!");
      onClose();
    } catch (error) {
      console.error("Ошибка обновления:", error);
      alert("Ошибка при обновлении!");
    } finally {
      setLoading(false);
       window.location.reload();
    }
  };

  const handleDelete = async () => {
    if (!product) return;

    try {
      setDeleteLoading(true);
      if (product.imageUrl) {
        const imageRef = ref(storage, product.imageUrl); // Получаем ссылку на изображение
        await deleteObject(imageRef);
      }

      const productRef = doc(db, "products", product.id);
      await deleteDoc(productRef);

      alert("Продукт удален!");
      onClose();
    } catch (error) {
      console.error("Ошибка при удалении товара:", error);
      alert("Ошибка при удалении товара!");
    } finally {
      setDeleteLoading(false);
      setLoading(false);
      window.location.reload();
    }
  };

  return (
    <div className="editProduct productCard-modal">
      <div className="editProduct-content">
        {Object.entries(formData).map(([key, value]) => (
          <div className="editProduct-content-item" key={key}>
            <label htmlFor={key}>{key}</label>
            <input
              className="input"
              id={key}
              name={key}
              type="text"
              value={value}
              onChange={handleChange}
            />
          </div>
        ))}
        <div className="editProduct-content-item">
          <label htmlFor="country">Страны</label>
          <Select
            className="basic-multi-select"
            classNamePrefix="select"
            isMulti
            options={countryOptions}
            value={selectedCountries}
            onChange={handleSelectChange}
          />
        </div>

        <div className="editProduct-content-item">
          <img
            src={typeof img === "string" ? img : URL.createObjectURL(img)}
            width={100}
            alt="Product"
          />
          <label htmlFor="image">Редактировать картинку</label>
          <input
            type="file"
            accept="image/*"
            name="image"
            id="image"
            onChange={handleImageChange}
          />
        </div>

        <div className="editProduct-buttons">
          <Button
            onClick={handleUpdate}
            disabled={loading}
            title="Обновить"
            color="blue"
          ></Button>

          <Button
            onClick={handleDelete}
            title="Удалить товар"
            color="red"
            disabled={deleteLoading}
          ></Button>

          <Button onClick={onClose} title="Закрыть" color="gray"></Button>
        </div>
      </div>
    </div>
  );
};

export default EditProduct;
